import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ConfigurationMessagesDialogComponent} from '../configuration-messages-dialog/configuration-messages-dialog.component';
import {Sku} from '../../../model/sku';
import {SelectionUtils} from '../../selection-utils';
import {IecLeadTime} from '../../../model/iec-lead-time';
import {SfrEntry} from '../../../model/sfr-entry';
import { MatButton } from '@angular/material/button';
import { LeadTimeRowComponent } from '../lead-time-row/lead-time-row.component';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-skus-and-prices',
    templateUrl: './skus-and-prices.component.html',
    styleUrls: ['./skus-and-prices.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LeadTimeRowComponent, MatButton, CurrencyPipe]
})
export class SkusAndPricesComponent implements OnChanges {
  private dialog = inject(MatDialog);


  readonly modelImagePath = input<string>(undefined!);
  readonly messages = input<string[]>(undefined!);
  readonly uniqueMessages = computed(() => this.getUniqueMessages());
  readonly skus = input.required<Sku[]>();
  readonly sfrEntries = input.required<SfrEntry[]>();
  readonly entityLeadTime = input.required<IecLeadTime>();
  readonly configurationLeadTime = input.required<IecLeadTime>();
  readonly sfrFlagChanged = output<void>();
  overriddenSlots: string[] = [];

  ngOnChanges(): void {
    this.loadOverriddenSlots();
  }

  private getUniqueMessages(): string[] {
    return (this.messages() || []).filter((value, index, self) => self.indexOf(value) === index);
  }

  showMessages(): void {
    this.dialog.open(ConfigurationMessagesDialogComponent, {
      height: '540px',
      width: '800px',
      data: {messages: this.uniqueMessages()},
    });
  }

  getTotalPrice(): number {
    return SelectionUtils.getConfigurationPrice(this.skus(), this.sfrEntries());
  }

  getSfrPrice(sfrEntry: SfrEntry): number {
    return sfrEntry.ignore ? 0 : sfrEntry.price;
  }

  getSkuPrice(sku: Sku): number {
    return this.isOverridden(sku) ? 0 : sku.price;
  }

  isOverridden(sku: Sku): boolean {
    return this.overriddenSlots.indexOf(sku.name) >= 0;
  }

  ignoreFlagChanged(sfrEntry: SfrEntry): void {
    sfrEntry.ignore = !sfrEntry.ignore;
    this.loadOverriddenSlots();
    this.sfrFlagChanged.emit();
  }


  private loadOverriddenSlots(): void {
    if (this.sfrEntries() && this.sfrEntries().length > 0) {
      this.overriddenSlots = this.sfrEntries().filter(sfr => !sfr.ignore).flatMap(sfr => sfr.skus);
    }
  }

}
